import React from 'react'
import Banner from './Banner'
import GetinTouch from './GetinTouch'

export default function ContactUs() {
  return (
    
    <main>
        <Banner/>
        <GetinTouch/>
    </main>
  )
}
